export interface IColumn {
  Header: string;
  accessor: string;
  width: number;
}

const columns = [
  {
    Header: 'Beneficiary Name',
    accessor: 'beneficiaryName',
    width: 120,
  },
  {
    Header: 'Network',
    accessor: 'netWork',
    width: 100,
  },
  {
    Header: 'Beneficiary Wallet Number',
    accessor: 'beneficiaryWalletNumber',
    width: 120,
  },
  {
    Header: 'Wallet Name',
    accessor: 'walletName',
    width: 120,
  },
  {
    Header: 'Amount',
    accessor: 'amount',
    width: 120,
  },
  {
    Header: 'Description',
    accessor: 'narration',
    width: 120,
  },
  {
    Header: 'Status',
    accessor: 'description',
    width: 260,
  },
];

export default columns;
